import { Component, Input } from "@angular/core";
import { CMovementOrder } from "../../model/action-tablet.model";

@Component({
    selector: 'app-action-tablet-waiting-movement-orders',
    templateUrl: './action-tablet-waiting-movement-orders.component.html',
    styleUrls: ['./action-tablet-waiting-movement-orders.component.scss'],
    standalone: false
})
export class ActionTabletWaitingMovementOrders {


  @Input() movementOrders: Array<CMovementOrder>;

  constructor() {

  }
}